module.exports = __webpack_public_path__ + "img/powered2.1.303139e9.png";